import { EntityId } from 'entities-next/common'
import { DASHBOARD_PATH } from 'scenes/Dashboard/Dashboard.routes'

export const SCOUTING_CAMPAIGN_MANAGER_PATH = `${DASHBOARD_PATH}/scouting-campaigns`
export const SCOUTING_CAMPAIGN_MANAGER_LIST_PATH = SCOUTING_CAMPAIGN_MANAGER_PATH
export const SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH = `${SCOUTING_CAMPAIGN_MANAGER_LIST_PATH}/:scoutingCampaignId`
export const SCOUTING_CAMPAIGN_MANAGER_NEW_USER = `${SCOUTING_CAMPAIGN_MANAGER_LIST_PATH}/new`

export function getScoutingCampaignDetailsPath(scoutingCampaignId: EntityId) {
  return `${SCOUTING_CAMPAIGN_MANAGER_LIST_PATH}/${scoutingCampaignId}`
}
